import $ from 'jquery';
import showFlash from 'legacy/javascripts/alerts.js';

$(function () {
  let otpSent = false;
  const $submit = $('.js-login-submit');
  const $loginGroup = $('.js-login-group');
  const $login = $('.js-login');
  const $passwordGroup = $('.js-password-group');
  const $password = $('.js-password');
  const $otpEnabled = $('.js-otp-enabled');
  const $resendOtp = $('.js-resend-otp');
  const $instructions = $('.js-otp-instructions');
  const $otpAttempt = $('.js-otp-attempt');
  const $otpDigits = $('.otp-digit');

  if (!$otpEnabled.length) {
    return
  }
  let timerInterval = null; // Store the interval so we can clear it

  // OTP digit input handlers
  function updateHiddenField() {
    const code = Array.from($otpDigits).map(input => input.value).join('');
    $otpAttempt.val(code);
  }

  $otpDigits.on('input', function (e) {
    const $input = $(this);
    const value = $input.val();

    // Allow only digits
    if (!/^\d*$/.test(value)) {
      $input.val('');
      return;
    }

    updateHiddenField();

    // Move to next input if digit entered
    if (value.length === 1) {
      const nextIndex = parseInt($input.data('index')) + 1;
      if (nextIndex < 6) {
        $(`.otp-digit[data-index="${nextIndex}"]`).focus();
      }
    }
  });

  $otpDigits.on('keydown', function (e) {
    const $input = $(this);
    const index = parseInt($input.data('index'));

    // Handle backspace
    if (e.key === 'Backspace' && !$input.val() && index > 0) {
      $(`.otp-digit[data-index="${index - 1}"]`).focus();
    }
    // Handle arrow keys
    else if (e.key === 'ArrowLeft' && index > 0) {
      e.preventDefault();
      $(`.otp-digit[data-index="${index - 1}"]`).focus();
    }
    else if (e.key === 'ArrowRight' && index < 5) {
      e.preventDefault();
      $(`.otp-digit[data-index="${index + 1}"]`).focus();
    }
  });

  // Handle paste
  $otpDigits.on('paste', function (e) {
    e.preventDefault();
    const pastedData = e.originalEvent.clipboardData.getData('text').replace(/\D/g, '');

    if (pastedData.length >= 6) {
      $otpDigits.each(function (i) {
        $(this).val(pastedData[i] || '');
      });
      updateHiddenField();
      $otpDigits.last().focus();
    }
  });

  // Clear all inputs when resending OTP
  function clearOtpInputs() {
    $otpDigits.val('');
    $otpAttempt.val('');
    $('.otp-digit[data-index="0"]').focus();
  }

  function startCountdown(ts) {
    if (timerInterval) {
      clearInterval(timerInterval);
    }

    const $timerContainer = $('#countdown-timer');

    $timerContainer.html("Didn't receive a code? Available in: <span id='time-left'>--:--</span>");

    const $timerDisplay = $('#time-left');
    $timerContainer.removeClass('hidden').show();

    const expirationTime = ts * 1000;

    const updateTimer = function () {
      const now = new Date().getTime();
      const distance = expirationTime - now;

      if (distance > 0) {
        const minutes = Math.floor(distance / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

        $timerDisplay.text(minutes + ":" + formattedSeconds);

      } else {
        // Time has expired
        clearInterval(timerInterval);
        $timerContainer.text("Didn't receive a code? Available to resend");
      }
    };

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
  }

  const requestCode = function () {
    $.ajax({
      url: `${window.location.protocol}//${window.location.host}/employees/otp`,
      type: 'POST',
      data: {
        login: $login.val(),
        password: $password.val()
      },
      dataType: 'json',
      success: function (data) {
        otpSent = true;
        const canSendAt = data.can_send_at;
        $instructions.removeClass('hidden');
        $passwordGroup.addClass('hidden');
        $loginGroup.addClass('hidden');
        $otpEnabled.removeClass('hidden');
        $resendOtp.removeClass('hidden');
        showFlash('success', 'Please enter the one time code sent to your email.')
        startCountdown(canSendAt);
        // Focus first OTP input
        $('.otp-digit[data-index="0"]').focus();
      },
      error: function (xhr, status, error) {
        const message = xhr.responseJSON?.error || error
        showFlash('error', message)
      }
    })
  }

  $submit.on('click', function (e) {
    if (!otpSent) {
      e.preventDefault();
      requestCode();
    }
  });

  $resendOtp.on('click', function (e) {
    e.preventDefault();
    clearOtpInputs();
    requestCode();
  });
});
